export const taskConfigDefault= {
    taskName:'',
    packageName:'',
    appData:'',
    minPackageVersion:'',
    requiredData:'',
    model:'',
    initialModelId:'',
    initialModelName:'',
    deviceQuery:[],
    estimatedDevices:2,
    minDataSize: 0,
    maxDataSize: 100000,
    dataSizeGte : 0,
    dataSizeLte : 0,
    numOfTargetTrainingRequestDevicesPerRound: null,
    numOfTargetTrainingResponseDevicesPerRound: null,
    numOfTargetEvaluationRequestDevicesPerRound: null,
    numOfTargetEvaluationResponseDevicesPerRound: null,
    numOfTargetTestRequestDevices : 0,
    numOfTargetTestResponseDevices : 0,
    samplingMethod:'random',
    samplingParameter:{
      samplingTemperature:0.8,
      lossSelectionWeight:0.5,
      recencyWeight:0.2,
      algorithm:'globalMinLoss',
      lossPriority:'low',
      referenceRound:'latest',
    },
    aggregationAlgorithm:'FedAvg',
    aggregationSelectionMethod:'FIRST_COME',
    maxRound:'2',
    roundTimeout:'15',
    extraTimeout:'60',
    epoch:10,
    batchSize:32,
    dropReminder:false, 
    additionalParams: {},
    modelType:'',
    numOfClasses:null,
  }